export function setStore(name, value) {
  if (!name) return;
  if (typeof value !== "string") {
    value = JSON.stringify(value);
  }
  window.localStorage.setItem(name, value);
}

export function getStore(name) {
  budo_log.debug("#10 store-name", name)

  if (!name) return;
  let value = window.localStorage.getItem(name);
  var ret = value && value !== 'undefined' ? JSON.parse(value) : null;

  budo_log.debug("#10 store-name", name, ret)
  return ret
}

export function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
}
